/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
/* global emailFriend, googleMapIt, aBoothEmail, rBoothEmail, aBoothWeb, rBoothWeb  */

expocadfx.exhibitorInfo = function() {
    var data = expocadfx.fxData;
    var config = expocadfx.config;
    var txt = expocadfx.txt;
    var fxStyle = expocadfx.styles;
    var elemById = expocadfx.element.elementById;
	var emailLink = expocadfx.emailLinkBuilder;
	var openEmail = expocadfx.openEmail;
	var navTo = expocadfx.util.navigateTo;
    var FxEvent = expocadfx.fxevent;
    var ExhibitorWindow = expocadfx.ExhibitorWindow;
    var getHeader = expocadfx.printHeader;
    var prtList = expocadfx.printList;
	var util = expocadfx.util;
    
    var doc = document;
    var winExhibInfo = null;
    var table = elemById( "exhibitorContact");
    
    var rows = null;
    var adr = "";
    var loc = "";
    var i = 0;
    var arExh = [];
    var boothType = "";
    var arBoothNumbers = [];
    var availableBoothObj = null;
    var exhibitorObj = null;
    var currentBoothObj = null;
    var bInfo = elemById( "boothInfo");		//  booth links
	var divOtherBooths = elemById( "otherBoothLinks");
	var otherBoothIndexes = [];
    
    
	winExhibInfo = new ExhibitorWindow( txt, fxStyle);
	winExhibInfo.window.addEventListener( "Dialog_Closed", reset);
	doc.addEventListener( "Favorite_Change", checkFavChange);
	
	table = doc.getElementsByTagName( "table")[0];   // change name

	elemById( "hdrCnt").innerHTML = txt.CONTACT;
	elemById( "hdrPrf").innerHTML = txt.PROFILE;
	elemById( "hdrCat").innerHTML = txt.CATEGORIES;
	elemById( "hdrOtherBooths").innerHTML = txt.OTHER_BOOTHS;
	
	if( config.bMapAddress) {
		elemById( "mapAddr").textContent = txt.NEW_MAP_ADDRESS;
	}
	
	rows = contactTable();

	rows.email.row.addEventListener( "click", emailLinkClickHandler);
	rows.web.row.addEventListener( "click", webLinkClickHandler);
    if ( config.bPopUpShare) {
        elemById( "shareEma").addEventListener( "click", emailButtonClickHandler);
        if (location.protocol !== 'https:' && location.hostname !== "localhost"){
            elemById( "sharePage").addEventListener( "click", newPageClickHandler);

        } else {
            elemById( "shareCop").addEventListener( "click", copyButtonClickHandler);
        }
        elemById( "shareTwi").addEventListener( "click", twitterButtonClickHandler);
        elemById( "shareFac").addEventListener( "click", facebookButtonClickHandler);
    }
//	bInfo = elemById( "boothInfo");
	

	if( config.bPopUpPrint) {
		elemById( "ei_print").addEventListener( "click", printExhInfo);
	}
	winExhibInfo.content.scrollTop = 0;
    
	
    
    function contactTable() {
        var row1 = elemById( "contactRow");
        var row = null;
        var obj = {};
        obj.contact = assignFields( row1, txt.CONTACT, "contact-text" );
        
        row = row1.cloneNode( true);
        obj.phone = assignFields( row, txt.PHONE, "contact-text" );
        
        row = row1.cloneNode( true);
        obj.fax = assignFields( row, txt.FAX, "contact-text" );
        
        row = row1.cloneNode( true);
        obj.email = assignFields( row, txt.EMAIL_C, "contact-link" );
        
        row = row1.cloneNode( true);
        obj.web = assignFields( row, txt.WEB_SITE, "contact-link" );
        return obj;
    }
    
    function assignFields( row, label, fieldClass) {
        var fields = row.getElementsByTagName( "td");
        fields[0].textContent = label;
        fields[1].setAttribute( "class", fieldClass);
        return ( { row:row, field:fields[1]});
    }
    
    function emailButtonClickHandler() {
        var num = boothType === "Available" ? availableBoothObj.number : arBoothNumbers.join(",");
		var name = boothType === "Available" ? "Available" : exhibitorObj.name;
        var body = emailLink( num);
        
        if( !config.bUseApi || String( emailFriend( num, body, name)) === "1") {
			openEmail( body);
        }
    }
    function twitterButtonClickHandler(e) {
        var num = boothType === "Available" ? availableBoothObj.number : arBoothNumbers.join(",");
		var name = boothType === "Available" ? "Available" : exhibitorObj.name;
        var body = emailLink( num);
        
        if( !config.bUseApi || String( emailFriend( num, body, name)) === "1") {
            e.preventDefault();
            var twitterWindow = window.open('https://twitter.com/share?url=' + body, 'twitter-popup', 'height=350,width=600');
            if(twitterWindow.focus) { twitterWindow.focus(); }
                return false;
        }
    }
    function facebookButtonClickHandler(e) {
        var num = boothType === "Available" ? availableBoothObj.number : arBoothNumbers.join(",");
		var name = boothType === "Available" ? "Available" : exhibitorObj.name;
        var body = emailLink( num);
        
        if( !config.bUseApi || String( emailFriend( num, body, name)) === "1") {
            e.preventDefault();
            var facebookWindow = window.open('https://www.facebook.com/sharer/sharer.php?u=' + body, 'facebook-popup', 'height=350,width=600');
            if(facebookWindow.focus) { facebookWindow.focus(); }
                return false;
        }
    }
    function copyButtonClickHandler(){
        var num = boothType === "Available" ? availableBoothObj.number : arBoothNumbers.join(",");
		var name = boothType === "Available" ? "Available" : exhibitorObj.name;
        var body = emailLink( num);
        if( !config.bUseApi || String( emailFriend( num, body, name)) === "1") {
            navigator.clipboard.writeText(body).then(function() {
                swal('','Link copied to Clipboard!', 'success');
            }, function(err) {
                swal('Something Went Wrong','Could not copy link!', 'error');
            });
        }
    }
    function newPageClickHandler(){
        var num = boothType === "Available" ? availableBoothObj.number : arBoothNumbers.join(",");
		var name = boothType === "Available" ? "Available" : exhibitorObj.name;
        var body = emailLink( num);
        if( !config.bUseApi || String( emailFriend( num, body, name)) === "1") {
            window.open(body, '_blank');
        }
    }
    function printExhInfo() {
        var hdr = getHeader( config.eventTitle, config.viewTitle, config.hasMultipleViews);
        var info = {};
        info.style = ".dialog__actions{display:none}";
        info.content = winExhibInfo.window.cloneNode( true);
        prtList( hdr, info);
    }
    
    function reset() {
        var links = bInfo.getElementsByTagName( "p");
        var i = links.length;
        
        while( i > 0) {
            i -= 1;
            links[i].removeEventListener( "click", boothLinkClickHandler);
            links[i].removeEventListener( "mouseover", boothLinkMouseOverHandler);
            links[i].removeEventListener( "mouseout", boothLinkMouseOutHandler);
        }
		
//		if( winLinkPreview) {
		
        bInfo.innerHTML = "";

        while( table.lastChild) {
            table.removeChild( table.lastChild);
        }
        
		exhibitorObj = null;
		availableBoothObj = null;
        arBoothNumbers = [];
		otherBoothIndexes = [];
		divOtherBooths.innerHTML = "";
		elemById( "hdrOtherBooths").style.display = "none";
        elemById( "hdrCat").style.display = "none";
        elemById( "txtCategories").innerHTML = "";
        elemById( "hdrPrf").style.display = "none";
        elemById( "txtProfile").innerHTML = "";
        elemById( "hdrCnt").style.display = "none";
        elemById( "addr").innerHTML = "";
        elemById( "exh").innerHTML = "";
        if (config.bPopUpPrint) {
            elemById( "ei_email").style.display = "inline-block";
        }
        
        winExhibInfo.content.scrollTop = 0;
        elemById( "mapAddr").style.display = "none";
    }
    
 ////////////////////////////////////  ENTRY POINT  ////////////////////////////////////////   
    function populateFromFloorPlan( bthObject) {        //  BOOTH CLICK !!!
		var boothIndex = bthObject.index;
		var len = data.displayBooths.length;
		var exhibitorName = "";
		var i = 0;
		
        reset();		//  need to reset in case booth changes without closing
        if( bthObject.status === "0") {
            boothType = "Available";
            
            availableBooth( bthObject);
        }
        else {
            boothType = "Rented";
            
            arExh = String(bthObject.exhibitorIndex).split( ",");

            if( arExh.length > 1) {
				if( config.bPopUpShare) {
                    elemById( "ei_email").style.display = "none";
                }
                multiExhibitor( bthObject);
            }
            else {
				exhibitorName = data.exhibitors[ bthObject.exhibitorIndex].name;
					// see if exhibitor has other booths  -- put them some where else !
				for( i = 0; i < len; i++) {
					if( data.displayBooths[i].name === exhibitorName &&
							data.displayBooths[i].boothNumber !== bthObject.number) {
						
						otherBoothIndexes.push( data.displayBooths[i].arBoothIndexes[0]);
					}
				}
                singleExhibitor( arExh[0], boothIndex, true);
            }
        }
    }
/////////////////////////////////////////////////////  ENTRY POINT  /////////////////////    
    function populateFromExhibitorList( exhibitorIndex, boothIndex) {
		var bthObj = data.booths[ boothIndex.split( ",")[0]];
		
        reset();
		
		if( bthObj.status === "0") {
            boothType = "Available";
            availableBooth( bthObj);
		}
		else {
			boothType = "Rented";
			singleExhibitor( exhibitorIndex, boothIndex, false);
		}
    }
////////////////////////////////////////////////////////////////////////////////////////   
    
    //  delay - getting event - delayed click? - when tapping booth on mobile device!
    function openWindow() {
        setTimeout( function() {
            winExhibInfo.window.style.display = "block";
        }, 300);
    }
    
    function boothLinkMouseOverHandler( evt) {
        doc.dispatchEvent( new FxEvent( 
            "Highlight_Booth", {"index": evt.currentTarget.getAttribute( "data-index")}));
    }
    
    function boothLinkMouseOutHandler( evt) {
        doc.dispatchEvent( new FxEvent( 
            "Unhighlight_Booth", {"index": evt.currentTarget.getAttribute( "data-index")}));
    }
    
    function boothLinkClickHandler( evt) {
		var obj = null;
		var index = evt.currentTarget.getAttribute( "data-index");
		var favorite = false;
		var booth = null;
		var exhibitorName = "";
		
		if( util.hasClass( evt.target, "icon")) {
			favorite = util.hasClass( evt.target, "icon-star-filled");
			booth = data.booths[ index];
			
			if( !exhibitorObj) {
				exhibitorObj = data.exhibitors[ booth.exhibitorIndex];
			}
			exhibitorObj.favorite = !favorite;
			
			exhibitorName = booth.status === "0" ? "" : exhibitorObj.name;
			obj = {
				boothIndex: index,
				boothNumber: booth.number,
				exhName: exhibitorName,
				exhId: exhibitorObj.exhId,
				source: "ExhibitorInfoDialog",
				local: true,
				fav: !favorite
			};
			
			if( favorite) {
				util.removeClass( evt.target, "icon-star-filled");
				util.addClass( evt.target, "icon-star-outline");
			}
			else {
				util.removeClass( evt.target, "icon-star-outline");
				util.addClass( evt.target, "icon-star-filled");
			}
			
			doc.dispatchEvent( new FxEvent( "Exhibitor_Info_Fav_Change", obj));
		}
		else {
			doc.dispatchEvent( new FxEvent( "Booth_Selected", {"boothIndex": index}));
		}
    }
    
    function createBoothLink( bth, exhId) {
        var sp;
		var icon = doc.createElement( "span");
        var str = doc.createElement( "p");
        str.setAttribute( "class", "bthDesc");
        str.setAttribute( "data-index", bth.index);
        
        sp = doc.createElement( "span");
        sp.textContent = txt.BOOTH + ": " + bth.number;
		
		if( isFavorite( bth.number, exhId)) {
			icon.className = "icon icon-star-filled";		// can not assign to 'classlist in IE11
		}
		else {
			icon.className = "icon icon-star-outline";
		}
		str.appendChild( icon);
        str.appendChild( sp);
        
        sp = doc.createElement( "span");
        
        bSize = getBoothSize(bth);
        if(bSize.trim() != ""){
            sp.textContent = "   " + txt.BOOTH_SIZE + ": " + bSize;
        }
        else{
            sp.textContent = "";
        }
        
        str.appendChild( sp);
        str.addEventListener( "click", boothLinkClickHandler);
        str.addEventListener( "mouseover", boothLinkMouseOverHandler);
        str.addEventListener( "mouseout", boothLinkMouseOutHandler);
        
        return str;
    }
	
	function isFavorite( bthNum, exhId) {
		var len = data.favoriteBooths.length;
		var i = 0;
		
		for( i = 0; i < len; i++) {
			if( data.favoriteBooths[i].bth === bthNum &&
				data.favoriteBooths[i].exh === exhId) {
				return true;
			}
		}
		return false;
	}
	
	function checkFavChange( evt) {
        var links = bInfo.getElementsByTagName( "p");
        var len = links.length;
		var i = 0;
		var index = -1;
		
		for( i = 0; i < len; i++) {
			index = links[i].getAttribute( "data-index");
			
			if( index && data.booths[ index].number === evt.data.boothNumber) {
				if( evt.data.fav) {
					util.removeClass( links[i].firstChild, "icon-star-outline");
					util.addClass( links[i].firstChild, "icon-star-filled");
				}
				else {
					util.removeClass( links[i].firstChild, "icon-star-filled");
					util.addClass( links[i].firstChild, "icon-star-outline");
				}
			}
		}
	}
    
    function singleExhibitor( exhibitorIndex, boothIndex) {
        var arBth = null;
        var i = 0;
        var numRows = 0;
        var mapItTop = 26;
//		var par;
        var boothLink = null;
        currentBoothObj = null;
        
        exhibitorObj = data.exhibitors[ exhibitorIndex];
        
        if( exhibitorObj.url !== "") {
            navTo( exhibitorObj.url);
            return;
        }
        arBth = String( boothIndex).split( ",");
		
        for( i = 0; i < arBth.length; i++) {
            currentBoothObj = data.booths[ arBth[i] ];
            if( currentBoothObj === undefined) {
                console.log( "    No current booth - index string: " + boothIndex);
            }
			
            boothLink = createBoothLink( currentBoothObj, exhibitorObj.exhId);
			
            arBoothNumbers.push( currentBoothObj.number);
            bInfo.appendChild( boothLink);
			mapItTop += 24;
        }
		
        elemById( "exh").innerHTML = exhibitorObj.name;

        adr = exhibitorObj.address1 + "<br>";
        adr += ( exhibitorObj.address2 !== "") ? exhibitorObj.address2 + "<br>" : "";

        if(exhibitorObj.city !== "") {
            loc = exhibitorObj.city;
            loc += ( exhibitorObj.state !== "") ? ", " + exhibitorObj.state : "";
        }
        else {
            loc = ( exhibitorObj.state !== "") ? exhibitorObj.state : "";
        }
        loc += ( exhibitorObj.zip !== "") ? " " + exhibitorObj.zip : "";

        adr += ( loc !== "") ? loc + "<br>" : "";
        adr += ( exhibitorObj.country !== "") ? exhibitorObj.country + "</br>" : "";
        elemById( "addr").innerHTML = adr;
        
        if( config.bMapAddress && exhibitorObj.address1 !== "") {
            mapItTop = Math.max(bInfo.offsetHeight + elemById( "exh").offsetHeight, mapItTop);
            
            elemById( "mapAddr").style.top =  mapItTop + "px";
            elemById( "mapAddr").style.display = "block";
            elemById( "mapAddr").addEventListener( "click", mapHandler);
        }
        
        if( exhibitorObj.contact !== "") {
            rows.contact.field.innerHTML = exhibitorObj.contact;
            table.appendChild( rows.contact.row);
            numRows += 1;
        }
        if( exhibitorObj.phone !== "") {
            rows.phone.field.innerHTML = exhibitorObj.phone;
            table.appendChild( rows.phone.row);
            numRows += 1;
        }
        if( exhibitorObj.fax !== "") {
            rows.fax.field.innerHTML = exhibitorObj.fax;
            table.appendChild( rows.fax.row);
            numRows += 1;
        }
        if( exhibitorObj.email !== "") {
            rows.email.field.innerHTML = exhibitorObj.email;
            table.appendChild( rows.email.row);
            numRows += 1;
        }
        if( exhibitorObj.website !== "") {
            rows.web.field.innerHTML = exhibitorObj.website;
            table.appendChild( rows.web.row);
            numRows += 1;
        }
        if( numRows > 0) {
            elemById( "hdrCnt").style.display = "block";
        }
        
        var arr = exhibitorObj.category.split( "x%x");
        if( arr !== null && arr.length > 0 && arr[0] !== "") {
            elemById( "hdrCat").style.display = "block";
            elemById( "txtCategories").innerHTML = arr.join( "<br>");
        }
		
        if( exhibitorObj.profile !== "") {
            elemById( "hdrPrf").style.display = "block";
            elemById( "txtProfile").innerHTML = exhibitorObj.profile;
        }
		
		if( otherBoothIndexes.length > 0) {
			elemById( "hdrOtherBooths").style.display = "block";
			
			for( i = 0; i < otherBoothIndexes.length; i++) {
				currentBoothObj = data.booths[ otherBoothIndexes[i] ];
				if( currentBoothObj === undefined) {
					console.log( "    No current booth - index string: " + boothIndex);
				}
				
				boothLink = createBoothLink( currentBoothObj, exhibitorObj.exhId);
				divOtherBooths.appendChild( boothLink);
			}
		}

        data.selectedRow = -1;
        
        openWindow();
    }
    
    function mapHandler() {
        var address = exhibitorObj.address1;
        if( !config.bUseApi || String( googleMapIt( arBoothNumbers.join(","), exhibitorObj.exhId,
                                           exhibitorObj.name))) {
            address += ", " + exhibitorObj.city + ", " + exhibitorObj.state + ", " + exhibitorObj.zip;
            if( exhibitorObj.country !== "") {
                address += ", " + exhibitorObj.country;
            }
            navTo( "http://maps.google.com/maps?q=" +
                 encodeURIComponent( address),"_blank");
        }
    }
    
    function multiExhibitor( bth) {      // List each exhibitor in booth
        var newDiv = null;
        var newElem = null;
        var list = null;
        var item = null;
        
        newDiv = doc.createElement( "div");
        newElem = doc.createElement( "h3");
        newElem.textContent = "Booth:  " + bth.number;
        newDiv.appendChild( newElem);
        newElem = doc.createElement( "p");
        newElem.textContent = "This booth has more than one exhibitor.  Please select one.";
        newDiv.appendChild( newElem);
        list = doc.createElement( "ul");

        for( i = 0; i < arExh.length; i++) {
            item = doc.createElement("li");
            item.style.fontWeight = "bold";
            item.style.textDecoration = "underline";
            item.style.cursor = "pointer";
            item.innerHTML = data.exhibitors[ arExh[i]].name;
            list.appendChild( item);
        }
        newDiv.appendChild( list);

        list.onclick = function( evt) {    //  CHANGE TO list.addEventListener()
            var exhIndex = -1;
            for( i = 0; i < arExh.length; i++) {
                if( data.exhibitors[ arExh[i]].name === htmlDecode(evt.target.innerHTML)) {
                    exhIndex = arExh[i];
                    break;
                }
            }
            if( exhIndex !== -1) {
                reset();
                singleExhibitor( exhIndex, bth.index, true);
            }
            else {
             //   alert( "Error Finding Exhibitor index");
                swal("", "Error Finding Exhibitor index", "error");
            }
        };
        bInfo.appendChild( newDiv);
        
        openWindow();
    }
        
    function availableBooth( bthObj) {
        var hasContact = false;
        availableBoothObj = bthObj;
        
        if( data.exhibitors[ bthObj.exhibitorIndex].url !== "") {
           navTo( data.exhibitors[ bthObj.exhibitorIndex].url);
        }
        else {
            var boothLink = createBoothLink( bthObj, "");
            bInfo.appendChild( boothLink);

            if( bthObj.flyout !== "") {
                var p = doc.createElement( "p");
                p.innerHTML = bthObj.flyout;        // allows HTML line breaks in text
                bInfo.appendChild( p);
            }

            elemById( "exh").innerHTML = txt.AVAILABLE;

            adr = config.availableText1;

            if( config.availableText2 !== "NA") {
                adr += bthObj.number + config.availableText2;
            }

            elemById( "addr").innerHTML = adr;
            if( config.contactEmail !== "") {
                rows.email.field.innerHTML = config.contactEmail;
                table.appendChild( rows.email.row);
                hasContact = true;
            }

            if( config.availableUrl !== "") {
                rows.web.field.innerHTML = config.availableUrl;
                table.appendChild( rows.web.row);
                hasContact = true;
            }
            if( hasContact) {
                elemById( "hdrCnt").style.display = "block";
            }
        }
        data.selectedRow = -1;
        
        openWindow();
    }

    function emailLinkClickHandler() {
        var url = "";
        var subject = encodeURIComponent(config.eventTitle);
        subject = (subject === "") ? " " : subject;
        var body = "";
        
        if( boothType === "Available") {
            if(!config.bUseApi || String( aBoothEmail(availableBoothObj.number, config.contactEmail) === "1")) {
                body = encodeURIComponent(config.emailSubject1 + availableBoothObj.number + config.emailSubject2);
                url = "mailto:" + config.contactEmail + "?subject=" + subject + "&body=" + body;
                
                window.location.href = url;
            }
        }
        else {
            if( !config.bUseApi || 
				String( rBoothEmail( arBoothNumbers[0], exhibitorObj.exhId, exhibitorObj.email,
                                               exhibitorObj.name) === "1")) {
                url = "mailto:" + exhibitorObj.email + "?subject=" + subject;
                window.location.href = url;
            }
        }
    }
    
    function webLinkClickHandler() {
        if( boothType === "Available") {
            if( !config.bUseApi || String( aBoothWeb( availableBoothObj.number, config.availableUrl) === "1")) {
                navTo( config.availableUrl);
            }
        }
        else {
            if( !config.bUseApi || 
				String( rBoothWeb( arBoothNumbers[0], exhibitorObj.exhId, exhibitorObj.website,
                                             exhibitorObj.name) === "1")) {
                navTo( exhibitorObj.website);
            }
        }
    }
    
    function getBoothSize( bth) {
        var d = "";
        var a = "";
        if( config.units === "M") {
            d = bth.dimM;
            a = bth.areaM;
        }
        else {
            d = bth.dimF;
            a = bth.areaF;
        }
        if( d !== "") {
            d += "   ";
        }
        return " " + d + a;
    }
    
    function htmlDecode( input ) {
        return String(input)
            .replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');
    }
    
    function changeExhibitorName( value) {
        elemById( "exh").innerHTML = value;
    }
    
    return {
        changeExhibitorName: changeExhibitorName,
        populateFromExhibitorList : populateFromExhibitorList,
        populateFromFloorPlan : populateFromFloorPlan
    };
};